<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.07667 1.49134L2.21901 5.27653C1.4079 5.90739 0.75 7.25023 0.75 8.26863V14.9468C0.75 17.0376 2.45333 18.75 4.5442 18.75H14.9805C17.0714 18.75 18.7747 17.0376 18.7747 14.9558V8.3948C18.7747 7.30431 18.0447 5.90739 17.1525 5.28554L11.5828 1.38319C10.3211 0.499983 8.29334 0.545045 7.07667 1.49134Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
